import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const pdfOptions = {
  orientation: 'p',
  format: 'a4',
  unit: 'mm',
  compress: true,
};

export default function usePDFExport() {
  const captureAsImageData = async (element) => {
    const canvas = await html2canvas(element, {
      scale: 2,
      logging: false,
    });
    return canvas.toDataURL('image/png');
  };

  const exportAsPDF = async (ref, filename = 'analytics-report.pdf') => {
    if (!ref.current) return;

    const imgData = await captureAsImageData(ref.current);
    // eslint-disable-next-line new-cap
    const doc = new jsPDF(pdfOptions);
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    doc.addImage(imgData, 'PNG', 0, 0, width, height, undefined, 'FAST');
    doc.save(filename);
  };

  return { exportAsPDF };
}
